import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import jobs from '../images/job-search.png';
import http from '../Api/http';

const Jobs = () => {
    const { t } = useTranslation();
    const idImageRef = useRef();
    const licenseImageRef = useRef();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [failedMessage, setFailedMessage] = useState("");
    const [formData, setFormData] = useState({
        Id: 0,
        InsDate: new Date(),
        Name: '',
        Email: '',
        Phone: '',
        Notes: '',
        IdImage: null,
        LicenseImage: null
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: '' }));
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prev => ({ ...prev, [name]: files[0] }));
    };

    const validate = () => {
        let newErrors = {};
        if (!formData.Name || formData.Name.toString().trim() === "") newErrors.Name = t('requiredField');
        if (!formData.Phone || formData.Phone.toString().trim() === "") newErrors.Email = t('requiredField');
        // if (!formData.Notes || formData.Notes.toString().trim() === "") newErrors.Notes = t('requiredField');
        return newErrors;
    };

    const onSave = async (e) => {
        const newErrors = validate();        
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        let files = [];
        files.push(formData.IdImage);
        files.push(formData.LicenseImage);
        const obj = {
            Id: formData.Id,
            Name: formData.Name,
            Email: formData.Email,
            Phone: formData.Phone,
            Notes: formData.Notes,
            InsDate: new Date()
        }
        try {
            setLoading(true);
            setSubmitted(true);
            const result = await http.postMultipartAxios(http.actions.Careers.Save, obj, null, files,t);
            if (result.status === 200 && result.data.success) {
                setErrors({});
                setFormData({
                    Id: 0,
                    InsDate: new Date(),
                    Name: '',
                    Email: '',
                    Phone: '',
                    Notes: '',
                    IdImage: undefined,
                    LicenseImage: undefined,
                });
                if (idImageRef.current) idImageRef.current.value = '';
                if (licenseImageRef.current) licenseImageRef.current.value = '';
                setSuccessMessage(t('done'));
                setTimeout(() => setSuccessMessage(""), 3000); // إخفاء الرسالة بعد 3 ثواني
            } else {
                setFailedMessage(result.data.errorText || t('failed'));
                setTimeout(() => setFailedMessage(""), 3000);
            }
        }
        catch (e) {

        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-center flex flex-col items-center justify-center p-2">
            <div className="w-full max-w-6xl rounded-xl shadow-lg p-2 md:p-12">
                {/* Title */}
                <h1 className="text-3xl font-bold text-center mb-8 text-blue-600">
                    {t('applyJob')}
                </h1>

                {/* Info + Form Layout */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {/* Image Section */}
                    <div className="flex justify-center items-center">
                        <img src={jobs} alt="jobs" className="w-full max-w-xs" style={{ width: '220px' }} />
                    </div>

                    {/* Contact Form */}
                    <form className="space-y-1 w-full">
                        {successMessage && (
                            <div className="bg-green-100 text-green-800 p-2 rounded mb-2 text-center border border-green-400">
                                {successMessage}
                            </div>
                        )}
                        {failedMessage && (
                            <div className="bg-red-100 text-red-800 p-2 rounded mb-2 text-center border border-red-400">
                                {failedMessage}
                            </div>
                        )}
                        <div>
                            <label className="block mb-1 text-gray-700 font-medium">{t('yourName')}</label>
                            <input
                                name="Name"
                                type="text"
                                value={formData.Name}
                                onChange={handleChange}
                                required autoFocus
                                placeholder={t('yourName')}
                                className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            />
                            {errors.Name && (<p className="text-red-500 text-sm mt-1">{errors.Name}</p>)}
                        </div>

                        <div>
                            <label className="block mb-1 text-gray-700 font-medium">{t('phone')}</label>
                            <input
                                name="Phone"
                                type="text"
                                value={formData.Phone}
                                onChange={handleChange}
                                required
                                placeholder={t('yourPhone')}
                                className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            />
                            {errors.Phone && (<p className="text-red-500 text-sm mt-1">{errors.Phone}</p>)}
                        </div>

                        <div>
                            <label className="block mb-1 text-gray-700 font-medium">{t('email')}</label>
                            <input
                                name="Email"
                                type="email"
                                value={formData.Email}
                                onChange={handleChange}
                                required
                                placeholder={t('yourEmail')}
                                className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            />
                        </div>

                        <div>
                            <label className="block mb-1 text-gray-700 font-medium">{t('notes')}</label>
                            <input
                                name="Notes"
                                type="text"
                                value={formData.Notes}
                                onChange={handleChange}
                                required
                                placeholder={t('notes')}
                                className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            />
                        </div>

                        <div>
                            <label className="block mb-1 text-gray-700 font-medium">{t('idImage')}</label>
                            <input
                                ref={idImageRef}
                                name="IdImage"
                                type="file"
                                onChange={handleFileChange}
                                accept="image/*"
                                required
                                className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            />
                            {errors.IdImage && (<p className="text-red-500 text-sm mt-1">{errors.IdImage}</p>)}
                        </div>

                        <div>
                            <label className="block mb-1 text-gray-700 font-medium">{t('licenseImage')}</label>
                            <input
                                ref={licenseImageRef}
                                name="LicenseImage"
                                type="file"
                                onChange={handleFileChange}
                                accept="image/*"
                                required
                                className="w-full border border-gray-300 p-1 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            />
                            {errors.LicenseImage && (<p className="text-red-500 text-sm mt-1">{errors.LicenseImage}</p>)}
                        </div>

                        <div>
                            <button
                                type="button"
                                onClick={() => {
                                    setSubmitted(true);
                                    onSave();
                                }}
                                className="w-1/2 bg-blue-600 text-white px-4 py-3 rounded hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 outline-none"
                            >
                                {t('saveReq')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );

};

export default Jobs;
